import React, {useEffect, useState} from "react";
import {getOtherRoles} from 'api';
import {Button, Form, Input, Table, Row, Col, Modal} from "antd";
import {confirmAlert} from "react-confirm-alert";
import {isAdministrator} from "../../../utils/UserInfo";
import AddOtherRoleDialog from "./AddOtherRoleDialog";
import {
    commonSorter,
    SearchAndDropdownComponent,
    searchAndDropDownFilters,
    searchAndDropDownOnFilters
} from "../../../utils/AntdTableFunctions";

function OtherRoleView(props){

    const [otherRoles,setOtherRoles] = useState([]);

    useEffect(() => {
        async function getData() {
            let roles = await getOtherRoles();
            setOtherRoles(roles);
        }
        getData();
    }, []);

    function OpenNewOtherRoleDialog()
    {
        confirmAlert({
            closeOnClickOutside: false,
            closeOnEscape: false,
            customUI: ({ onClose }) => {
                return (
                    <AddOtherRoleDialog onClose={onClose} setOtherRoles={setOtherRoles}/>
                );
            }
        });
    }

    const roleColumns = [
        {
            title: 'Other Role ID',
            dataIndex: 'otherRoleId',
            key: 'otherRoleId',
            sorter: (a,b) => commonSorter(a,b,'otherRoleId'),
            //filters: searchAndDropDownFilters('otherRoleId', otherRoles),
            //...SearchAndDropdownComponent(),
            //onFilter: (value, record) =>  searchAndDropDownOnFilters(value, record,'otherRoleName'),
        },
        {
            title: 'Other Role Name',
            dataIndex: 'otherRoleName',
            key: 'otherRoleName',
            sorter: (a,b) => commonSorter(a,b,'otherRoleName'),
            filters: searchAndDropDownFilters('otherRoleName', otherRoles),
            ...SearchAndDropdownComponent(),
            onFilter: (value, record) =>  searchAndDropDownOnFilters(value, record,'otherRoleName'),
        },
        {
            title: 'Added By',
            dataIndex: 'createdByName',
            key: 'createdByName'
        },
        {
            title: 'Added Date',
            dataIndex: 'createdDate',
            key: 'createdDate'
        },
        {
            title: 'Edited By',
            dataIndex: 'lastModifiedByName',
            key: 'lastModifiedByName'
        },
        {
            title: 'Edited Date',
            dataIndex: 'lastModifiedDate',
            key: 'lastModifiedDate'
        }
    ];

    return (
        <div>
            <div>
                <Row>
                    <Col>
                        {isAdministrator() &&
                        <Button
                            type='primary'
                            style={{alignItems: 'end', alignContent: 'end'}}
                            onClick={() => OpenNewOtherRoleDialog()}
                        >
                            Add New Other Role
                        </Button>
                        }
                    </Col>
                </Row>
            </div>
            <Table
                bordered
                dataSource={otherRoles}
                columns={roleColumns}
                pagination={false}
                scroll={{ y: true }}
                style={{ paddingTop: '15px', paddingBottom: '15px' }}
            />
        </div>
    )
}
export default OtherRoleView;